import { some, toUpper, replace } from 'lodash';

function isZipCodeServed({ zipCodesServed, zipCodeAnswer }) {
    const sanitZipCode = zipCode => replace(toUpper(zipCode), / /g, '');
    return some(zipCodesServed,
        servedZipCode => {
            return sanitZipCode(servedZipCode) === sanitZipCode(zipCodeAnswer) ||
                sanitZipCode(servedZipCode) === sanitZipCode(zipCodeAnswer).slice(0, 3);
        }
    );
}

export {
    isZipCodeServed
};
